import { useState } from "react";

const useLoyaltyCustomers = () => {
  const [isRefresh, setIsRefresh] = useState(false);

  return {
    isRefresh,
    setIsRefresh,
  };
};
export default useLoyaltyCustomers;
